import { observer } from "mobx-react-lite";
import { FC, useEffect } from "react";
import { AuthCardEmailPassword } from "@/components/auth/auth-card-email-password";
import { usePublicAppStore } from "@/store";
import { appRoutes } from "@/app/router";
import { AuthLayout } from "@/components/auth/layout/auth-layout";
import { localStorageModule } from "@/modules/local-storage";
import { useNavigate } from "react-router-dom";

export const LogInEmailPasswordPage: FC = observer(() => {
  const { publicStore } = usePublicAppStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!publicStore.auth.isAuthenticated) {
      return;
    }

    const asyncLogic = async () => {
      const { pathname, search, hash } = await localStorageModule.readPendingRedirectPath();
      await localStorageModule.clearPendingRedirectPath();

      const defaultRedirectPath = appRoutes.notesList({}).path;
      const targetPathname = pathname ?? defaultRedirectPath;

      if (!pathname) {
        navigate(targetPathname, { replace: true });
        return;
      }

      navigate(
        {
          pathname: targetPathname,
          search: search ?? undefined,
          hash: hash ?? undefined,
        },
        { replace: true }
      );
    };

    asyncLogic();
  }, [navigate, publicStore.auth.isAuthenticated]);

  if (publicStore.auth.isAuthenticated) {
    return null;
  }

  return (
    <AuthLayout>
      <AuthCardEmailPassword />
    </AuthLayout>
  );
});
